// Shared media distribution used by both staging and prod builds.
const DEFAULT_MEDIA_CDN_BASE_URL = "https://cdn.mydecisive.ai";
const MEDIA_LATEST_ROOT = "/media/latest";

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.trim().replace(/\/+$/, "");
}

function normalizeAssetPath(assetPath: string): string {
  return assetPath.trim().replace(/^\/+/, "");
}

function encodeAssetPath(assetPath: string): string {
  return assetPath
    .split("/")
    .filter((segment) => segment.length > 0)
    .map((segment) => encodeURIComponent(segment))
    .join("/");
}

export function getConfiguredMediaCdnBaseUrl(): string {
  const configured = import.meta.env.VITE_MEDIA_CDN_BASE_URL;
  if (typeof configured === "string" && configured.trim().length > 0) {
    return normalizeBaseUrl(configured);
  }

  return DEFAULT_MEDIA_CDN_BASE_URL;
}

export function buildCanonicalCdnAssetUrl(assetPath: string, mediaCdnBaseUrl = getConfiguredMediaCdnBaseUrl()): string {
  const normalizedPath = normalizeAssetPath(assetPath);
  const encodedPath = encodeAssetPath(normalizedPath);
  return `${normalizeBaseUrl(mediaCdnBaseUrl)}${MEDIA_LATEST_ROOT}/${encodedPath}`;
}

export function resolveCdnAssetUrl(assetPath: string): string {
  return buildCanonicalCdnAssetUrl(assetPath);
}
